import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { merge } from 'lodash';
import * as TYPES from '../types';
export default (function (_ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case TYPES.INIT:
      {
        // Analytics.init(apiKey)
        // See https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/quickstart/
        // Create a queue, but don't obliterate an existing one!
        var analytics = window.analytics = window.analytics || []; // If the real analytics.js is already on the page return.

        if (analytics.initialize) return; // If the snippet was invoked already show an error.

        if (analytics.invoked) {
          if (window.console && console.error) {
            console.error('Segment snippet included twice.');
          }

          return;
        } // Invoked flag, to make sure the snippet
        // is never invoked twice.


        analytics.invoked = true; // A list of the methods in Analytics.js to stub.

        analytics.methods = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on']; // Define a factory to create stubs. These are placeholders
        // for methods in Analytics.js so that you never have to wait
        // for it to load to actually record data. The `method` is
        // stored as the first argument, so we can replay the data.

        analytics.factory = function (method) {
          return function () {
            var args = _sliceInstanceProperty(Array.prototype).call(arguments);

            args.unshift(method);
            analytics.push(args);
            return analytics;
          };
        }; // For each of our methods, generate a queueing stub.


        for (var i = 0; i < analytics.methods.length; i++) {
          var key = analytics.methods[i];
          analytics[key] = analytics.factory(key);
        } // Define a method to load Analytics.js from our CDN,
        // and that will be sure to only ever load it once.


        analytics.load = function (key, options) {
          // Create an async script element based on your key.
          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.async = true;
          script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'; // Insert our script next to the first script element.

          var first = document.getElementsByTagName('script')[0];
          first.parentNode.insertBefore(script, first);
          analytics._loadOptions = options;
        }; // Add a version to keep track of what's in the wild.


        analytics.SNIPPET_VERSION = '4.1.0'; // Load Analytics.js with your key, which will automatically
        // load the tools you've enabled for your account. Boosh!

        analytics.load(payload);
        break;
      }

    case TYPES.IDENTIFY:
      {
        var _window$analytics, _window$analytics$ide;

        // Analytics.identify({ userId: x, name: foo, ... })
        if (!payload.userId) {
          console.error("No \"userId\" found in payload!");
          return;
        }

        (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : (_window$analytics$ide = _window$analytics.identify) === null || _window$analytics$ide === void 0 ? void 0 : _window$analytics$ide.call(_window$analytics, payload.userId, payload);
        break;
      }

    case TYPES.CUSTOM:
      {
        var _window$analytics2, _window$analytics2$tr;

        // Analytics.custom({ eventName, data, options })
        var _ref2 = payload || {},
            eventName = _ref2.eventName,
            data = _ref2.data,
            options = _ref2.options;

        var _ref3 = options || {},
            callback = _ref3.callback,
            rest = _objectWithoutProperties(_ref3, ["callback"]);

        (_window$analytics2 = window.analytics) === null || _window$analytics2 === void 0 ? void 0 : (_window$analytics2$tr = _window$analytics2.track) === null || _window$analytics2$tr === void 0 ? void 0 : _window$analytics2$tr.call(_window$analytics2, eventName, data, merge({}, {
          integrations: {
            FullStory: false
          }
        }, rest), callback);
        break;
      }

    case TYPES.INFORMATION:
      {
        var _window$analytics3, _window$analytics3$tr;

        // Analytics.information({ message, options, ... })
        var _ref4 = payload || {},
            message = _ref4.message,
            _options = _ref4.options,
            _rest = _objectWithoutProperties(_ref4, ["message", "options"]);

        (_window$analytics3 = window.analytics) === null || _window$analytics3 === void 0 ? void 0 : (_window$analytics3$tr = _window$analytics3.track) === null || _window$analytics3$tr === void 0 ? void 0 : _window$analytics3$tr.call(_window$analytics3, 'Information', _objectSpread({
          Message: message
        }, _rest), merge({}, {
          integrations: {
            FullStory: false
          }
        }, _options));
        break;
      }

    case TYPES.TRACK:
      {
        var _window$analytics4, _window$analytics4$tr;

        // Analytics.track({ options, ... })
        var _ref5 = payload || {},
            _options2 = _ref5.options,
            _data = _objectWithoutProperties(_ref5, ["options"]);

        (_window$analytics4 = window.analytics) === null || _window$analytics4 === void 0 ? void 0 : (_window$analytics4$tr = _window$analytics4.track) === null || _window$analytics4$tr === void 0 ? void 0 : _window$analytics4$tr.call(_window$analytics4, _data, _options2);
        break;
      }

    case TYPES.ERROR:
      {
        var _ref7;

        // Analytics.error({ error, options, ... })
        var _ref6 = payload || {},
            error = _ref6.error,
            _options3 = _ref6.options,
            _rest2 = _objectWithoutProperties(_ref6, ["error", "options"]);

        window.analytics.track('Error', _objectSpread({
          Error: (_ref7 = error === null || error === void 0 ? void 0 : error.message) !== null && _ref7 !== void 0 ? _ref7 : error
        }, _rest2), merge({}, {
          integrations: {
            FullStory: false
          }
        }, _options3));
        break;
      }

    case TYPES.PERFORMANCE:
      {
        console.warn('TODO: implement performance tracking');
        break;
      }

    case TYPES.NAVIGATION:
      {
        var _window$analytics5, _window$analytics5$pa, _window$Intercom, _window;

        // Analytics.navigation({ page, options, ... })
        var _ref8 = payload || {},
            page = _ref8.page,
            _options4 = _ref8.options,
            _rest3 = _objectWithoutProperties(_ref8, ["page", "options"]);

        (_window$analytics5 = window.analytics) === null || _window$analytics5 === void 0 ? void 0 : (_window$analytics5$pa = _window$analytics5.page) === null || _window$analytics5$pa === void 0 ? void 0 : _window$analytics5$pa.call(_window$analytics5, page, _rest3, // Intercom is not hit because we need to trigger an 'update' directly
        // otherwise they don't update the recent pages
        merge({}, {
          integrations: {
            Intercom: false
          }
        }, _options4));
        (_window$Intercom = (_window = window).Intercom) === null || _window$Intercom === void 0 ? void 0 : _window$Intercom.call(_window, 'update', {
          // eslint-disable-next-line
          last_request_at: _parseInt(new Date().getTime() / 1000)
        });
        break;
      }
  }
});